import { useEffect } from 'react'

export const BuildTime = () => {
  useEffect(() => {
    console.log(`Build time: ${__BUILD_TIME__}`)
  }, [])

  return (
    <div className="fixed top-0 right-1 text-sm font-normal text-muted opacity-[0.02] active:opacity-40 focus:opacity-40 z-100">
      {__BUILD_TIME__}
    </div>
  )
}
